import { render, staticRenderFns } from "./IconGridSelection.vue?vue&type=template&id=489095d3&"
import script from "./IconGridSelection.vue?vue&type=script&lang=js&"
export * from "./IconGridSelection.vue?vue&type=script&lang=js&"
import style0 from "./IconGridSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports